import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../api/api.service';
import { AppointmentListResponse } from '../../models/appointment/appointment.model';
import { BaseApiResponse } from '../../models/api/api.model';

@Injectable({
  providedIn: 'root',
})
export class AppointmentsService {
  constructor(private apiService: ApiService) {}

  private apiURL = `${environment.apiLocations.appointment}/Appointment`;

  getListAppointment(
    page: number,
    size: number,
    filters: any = {},
  ): Observable<BaseApiResponse<AppointmentListResponse>> {
    let params = new HttpParams()
      .set('PageIndex', page.toString())
      .set('PageSize', size.toString());

    if (filters.patientName) {
      params = params.set('PatientName', filters.patientName);
    }
    if (filters.bsnNumber) {
      params = params.set('BsnNumber', filters.bsnNumber);
    }
    if (filters.date) {
      const startDate = new Date(filters.date);
      startDate.setUTCHours(0, 0, 0, 0);

      const endDate = new Date(filters.date);
      endDate.setUTCHours(23, 59, 59, 999);

      params = params.set('StartDate', startDate.toISOString());
      params = params.set('EndDate', endDate.toISOString());
    }

    if (filters.sortBy) {
      params = params.set('SortBy', filters.sortBy);
    }
    if (filters.sortDirection) {
      params = params.set('SortDirection', filters.sortDirection);
    }

    params = params.set('Status', '1');

    const url = `${this.apiURL}/getListAppointment`;
    return this.apiService.get<AppointmentListResponse>(
      `${url}?${params.toString()}`,
    );
  }

  getAppointmentCount(): Observable<BaseApiResponse<number>> {
    const url = `${this.apiURL}/getAppointmentCount`;
    return this.apiService.get<number>(url);
  }
}
